import { Svgs } from "res";

const RocketLaunchIcon = () => {
  return <img src={Svgs.RocketLaunch} alt="" />;
};

export default RocketLaunchIcon;
